import {Sha256} from '@aws-crypto/sha256-browser'

class Azure {
  getCurrentUserId(cb) {
    cb(window.VSS.getWebContext().user.id);
  }

  getEmail() {
    return window.VSS.getWebContext().user.email;
  }

  fetchSubscriptionInfoForCurrentUser(cb, errorCb) {
    const user_email = window.VSS.getWebContext().user.email;
    const user_id = window.VSS.getWebContext().user.id;
    const organizationId = window.VSS.getWebContext()?.account?.id ?? 'unknown';
    const organization = `org-${organizationId}`;
    const sen = user_id ? user_id : organization;

    this._sendSignedRequestToBackend(
      'azure_fetchSubscriptionInfoForCurrentUser',
      { user: { email: user_email, id: user_id } },
      data => {
        const activeLicense = !!data.active;
        const evaluationLicense = !!data.is_trial;
        let customerType = 'Not Found'; // If no active license found
        if (activeLicense) customerType = !evaluationLicense ? 'Subscriber' : 'Evaluator';
        cb({ data: data });
      },
      errorCb
    )
     // alert(JSON.stringify(window.VSS.getWebContext().account))
     // alert(JSON.stringify(window.VSS.getWebContext().team))
  }

  fetchEAPAccess(callback) {
    const subscriptionId = window.VSS.getWebContext().user.subjectId;
    const organisation = window.VSS.getWebContext().account.name;

    this._sendSignedRequestToBackend(
      'azure_fetchEAPAccess',
      {
        subscriptionId: subscriptionId,
        organisation: organisation,
      },
      (data) => {
        callback({ data: data });
      },
    );
  }

  allowInviteCode(callback) {
    this._sendSignedRequestToBackend(
      'azure_allowInviteCode',
      {},
      data => { callback({ data: data }); }
    )
  }

  checkCouponCode(code, callback) {
    this._sendSignedRequestToBackend(
      'azure_checkCouponCode',
      { code },
      (data) => { callback({ data }); },
    );
  }

  createSubscription(cb) {
    const user_email = window.VSS.getWebContext().user.email;
    const user_id = window.VSS.getWebContext().user.id;

    this._sendSignedRequestToBackend(
      'azure_createSubscription',
      { user: { email: user_email, id: user_id } },
      data => { cb({ data: data }); }
    )
  }

  convertSubscription(opts, cb) {
    this._sendSignedRequestToBackend(
      'azure_convertSubscription', opts,
      data => { cb({ data: data }); }
    )
  }

  fetchAllUsers(opts, cb) {
    this._sendSignedRequestToBackend(
      'azure_fetchAllUsers',
      {},
      data => {
        this._map_user_ids(data.users, (new_users) => {
        cb({ data: { max_users: data.max_users, inviteCode: data.inviteCode, users: new_users } });
      })}
    )
  }

  regenerateInviteCode(opts, cb) {
    this._sendSignedRequestToBackend(
      'azure_generateInviteCode',
      {},
      data => {
        cb({ data: { inviteCode: data.inviteCode, code: data.code } });
      }
    );
  }

  redeemInviteCode(opts, cb) {
    this._sendSignedRequestToBackend(
      'azure_redeemInviteCode',
      { code: opts.code },
      data => { cb({ data: data }); }
    );
  }

  addCurrentBillingUserToManagedUsers(opts, cb) {
    this._sendSignedRequestToBackend(
      'azure_addCurrentBillingUserToManagedUsers',
      {},
      data => {
        this._map_user_ids(data.users, (new_users) => {
          data.users = new_users;
          cb({ data: data });
        })
      }
    );
  }

  removeUser(opts, cb) {
    this._sendSignedRequestToBackend(
      'azure_removeUser',
      { remove_user: opts.remove_user },
      data => {
        if (data) {
          this._map_user_ids(data, (new_users) => {
            cb({ data: new_users });
          })
        } else {
          cb({ data: data });
        }
      }
    )
  }

  _map_user_ids(user_ids, cb) {
    var fetch_user_list = (org, project, cb) => {
      window.VSS.require(["VSS/Authentication/Services"], function (VSS_Auth_Service) {
        window.VSS.getAccessToken().then(function(token) {
          const xhr = new XMLHttpRequest();
          xhr.addEventListener("load", function() {
            if (xhr.status !== 200) { cb([]) } else {
              cb(JSON.parse(xhr.responseText));
            }
          })
          xhr.addEventListener("error", () => { cb([]) })
          xhr.open(
            "GET",
            'https://analytics.dev.azure.com/' + encodeURIComponent(org) + '/' + encodeURIComponent(project) + '/_odata/Users?$select=' + encodeURIComponent('UserId,UserName,UserEmail')
          )
          const authHeader = VSS_Auth_Service.authTokenManager.getAuthorizationHeader(token);
          xhr.setRequestHeader('Authorization', authHeader)
          xhr.send()
        })
      })
    };
    fetch_user_list(window.VSS.getWebContext().account.name, window.VSS.getWebContext().project.name, (registered_users) => {
      var hashed_users = {};
      if (registered_users && registered_users.value) {
        registered_users.value.forEach(u => {
          hashed_users[u.UserId] = { email: u.UserEmail, displayName: u.UserName, uid: u.UserId };
        })
      }
      if (user_ids && user_ids.length > 0) {
        cb(user_ids.map(u_object => {
          return hashed_users[u_object.uid] ?
            hashed_users[u_object.uid]
            :
            { email:u_object.uid, displayName:'User not found', uid: u_object.uid}
        }))
      } else { cb([]); }
    });
  }

  _sendSignedRequestToBackend(function_name, data, cb, errorCb) {
    data.account_id = window.VSS.getWebContext().account.id;
    data.account_name = window.VSS.getWebContext().account.name;
    data.user_id = window.VSS.getWebContext().user.id;

    const base_url = '/actionable-agile/legacy/';

    window.VSS.getAppToken().then((token) => {
      const url = base_url + function_name;
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          Authorization: `JWT ${token.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          // Check if response is ok (status 200-299)
          if (!response.ok) {
            throw new Error(`Backend error: ${response.status} ${response.statusText}`);
          }
          // Check if response is JSON
          const contentType = response.headers.get('content-type');
          if (!contentType || !contentType.includes('application/json')) {
            throw new Error('Backend returned non-JSON response');
          }
          return response.json();
        })
        .then((data) => {
          cb(data);
        })
        .catch((error) => {
          console.error('Backend request failed:', error);
          // Call error callback if provided, otherwise throw
          if (errorCb) {
            errorCb(error);
          } else {
            throw error;
          }
        });
    });
  }
}

export default Azure;
